import { useDeviceType } from '@cian/ui-kit';

import { type FC, useMemo } from 'react';

import { type TMainpageBrandContext } from 'shared/types/bannerContext';
import { useAdfoxBannerContext } from 'shared/components/AdfoxBannerContext';
import { useMainPageBrandBannerEnrichments } from 'shared/hooks/useMainPageBrandBannerEnrichments';

import { getMainpageBrandCompleteContext } from './internal/utils/getMainpageBrandCompleteContext';
import { MainpageBrandDesktop } from './internal/components/MainpageBrandDesktop';
import { MainpageBrandMobileExperiment } from './internal/components/MainpageBrandMobileExperiment';

type TMainpageBrandContainerProps = {
  context: TMainpageBrandContext;
};

export const MainpageBrandContainer: FC<TMainpageBrandContainerProps> = ({ context }) => {
  const deviceType = useDeviceType();

  const { sizes } = useAdfoxBannerContext();

  const enrichments = useMainPageBrandBannerEnrichments(context);

  const completeContext = useMemo(
    () => getMainpageBrandCompleteContext({ context, enrichments, sizes }),
    [context, enrichments, sizes],
  );

  if (deviceType === 'desktop') {
    return <MainpageBrandDesktop completeContext={completeContext} />;
  }

  // Мобильная ветка под A/B: контроль (A) — текущий дизайн, B — новый.
  return <MainpageBrandMobileExperiment completeContext={completeContext} />;
};
